import { Injectable, signal } from '@angular/core';

import { CashierService } from '@frontend/vanilla/core';

import { ChannelType, ProductType } from '../config/appConstants';
import { QDInstrument } from '../model/qdInstrument.model';
import { DataService } from './data.service';
import { QuickDepositMessageService } from './quick-deposit-message.service';

@Injectable({
    providedIn: 'root',
})
export class OptionListService {
    _reversalExists = false;
    _selectedOption: QDInstrument;
    _optionList: QDInstrument[];
    dataLoading = signal<boolean>(false);
    _reversalArr: any[];

    constructor(
        private dataService: DataService,
        private cashierService: CashierService,
        private quickDepositMessageService: QuickDepositMessageService,
    ) {}

    set optionList(_optionList) {
        this._optionList = _optionList;
    }

    get optionList() {
        return this._optionList;
    }

    set selectedOption(_selectedOption) {
        this._selectedOption = _selectedOption;
    }

    get selectedOption() {
        return this._selectedOption;
    }

    set reversalExists(_reversalExists) {
        this._reversalExists = _reversalExists;
    }

    get reversalExists() {
        return this._reversalExists;
    }

    set reversalArr(_reversalArr: any[]) {
        this._reversalArr = _reversalArr;
    }

    get reversalArr() {
        return this._reversalArr;
    }

    redirectToMainCashier(module: string = '&type=options') {
        const channelId = this.dataService.sessionInfo?.channelId;
        if (channelId === ChannelType.VC || channelId === ChannelType.FC || channelId === ChannelType.MC) {
            this.postMessageToParent(this.dataService.sessionInfo?.productId, module);
        } else {
            this.cashierService.goToCashierDeposit({ skipQuickDeposit: true, queryParameters: { showAllOptions: 'true' } });
        }
    }

    postMessageToParent(productId: any, module = '') {
        let message = '';
        if (productId == ProductType.CASINO) {
            message = module == '&type=reverse-withdrawal' ? 'showReverseWithdrawal=true' : 'showAllOptions=true&parent=true';
        } else {
            message = 'showAllOptions=true';
        }
        message = `action=close&${message}`;
        this.quickDepositMessageService.sendOutput(message);
    }
}
